import { localStorageGet, localStorageSet, removeItem } from './index'

const CURRENTLANUGAGE = 'CURRENT_LANGUAGE';

//保存语言
export function setLanguageStore(data, expireTime) {
    localStorageSet(CURRENTLANUGAGE, data, expireTime)
}
//获取语言
export function getLanguageStore() {
    return localStorageGet(CURRENTLANUGAGE) || 'en_US';
}
